import React from "react";

const ErrorPage = () => {
  return (
    <div>
      <h1>
        {" "}
        Oops the Page you are looking for does not exist <a href="/">MOVE</a> to
        home{" "}
      </h1>
    </div>
  );
};

export default ErrorPage;
